import React from "react";
// import { Chrono } from "react-chrono";
// import { ChronoWrapper } from "./VerticalTimeline.styled";
// import { items } from "./mockData";
// import { useMediaQuery } from "../../../utils/useMediaQuery";

// const VerticalTimeline = () => {
//   // const isSmallerThan1000 = useMediaQuery("(max-width: 800px)");

//   return (
//     <ChronoWrapper className="ChronoWrapper">
//       <Chrono
//         items={items}
//         mode="VERTICAL_ALTERNATING"
//         activeItemIndex
//         // allowDynamicUpdate={false}
//         borderLessCards
//         disableNavOnKey
//         disableClickOnCircle
//         hideControls
//         // flipLayout={isSmallerThan1000 ? false : true}
//         cardWidth="400px"
//         cardHeight="200px"
//         lineWidth="1px;"
//         // focusActiveItemOnLoad="false"
//         theme={{
//           primary: "var(--main-color)",
//           secondary: "none",
//           cardBgColor: "none",
//           titleColor: "#fff",
//           titleColorActive: "none",
//         }}
//         fontSizes={{
//           cardSubtitle: "14px",
//           cardText: "14px",
//           cardTitle: "14px",
//           title: "14px",
//         }}
//         classNames={{
//           title: "my-title",
//           card: "my-card",
//         }}
//       />
//     </ChronoWrapper>
//   );
// };

// export default VerticalTimeline;

const VerticalTimeline = () => {
  return (
    <div className="timeline">
      <div className="container right">
        <div className="content">
          <p>
            <span
              style={{
                color: "var(--main-color)",
                display: "block",
                marginBottom: "20px",
              }}
            >
              Introduction
            </span>
            I collaborated with a client to revitalize their outdated website,
            focusing on improving their online presence. The project involved
            implementing a modern design, enhancing functionality, and
            optimizing the site’s speed for a seamless user experience.
          </p>
        </div>
        {/* <p className="heading-left">Introduction</p> */}
      </div>
      <div className="container left">
        <div className="content">
          <p>
            <span
              style={{
                color: "var(--main-color)",
                display: "block",
                marginBottom: "20px",
              }}
            >
              Challenge
            </span>
            Upon initial examination, the client's website was outdated,
            unresponsive, and had slow loading times, causing user frustration
            and negatively impacting the client's revenue. Through further
            analysis, I discovered that the website was not working as intended,
            and its design was unappealing and not user-friendly. Additionally,
            the website had several bugs and errors that adversely affected its
            functionality.
          </p>
        </div>
        {/* <p className="heading-right">Challenge</p> */}
      </div>
      <div className="container right">
        <div className="content">
          <p>
            <span
              style={{
                color: "var(--main-color)",
                display: "block",
                marginBottom: "20px",
              }}
            >
              Solution
            </span>
            To tackle these issues, I conducted a comprehensive analysis of the
            website to identify areas for improvement. Based on my findings, I
            developed a plan with a focus on three key areas: design,
            functionality, and speed.
          </p>
        </div>
        {/* <p className="heading-left">Solution</p> */}
      </div>
      <div className="container left">
        <div className="content">
          <p>
            <span
              style={{
                color: "var(--main-color)",
                display: "block",
                marginBottom: "20px",
              }}
            >
              Design
            </span>
            Beginning with the design, I revamped the website's appearance to
            give it a modern and user-friendly look. I simplified the navigation
            to make the website more intuitive and easy to use.
          </p>
        </div>
        {/* <p className="heading-right">Design</p> */}
      </div>
      <div className="container right">
        <div className="content">
          <p>
            <span
              style={{
                color: "var(--main-color)",
                display: "block",
                marginBottom: "20px",
              }}
            >
              Functionality
            </span>
            Next, I optimized the website's code and improved its performance by
            identifying and fixing any errors or bugs that impacted the
            website's functionality. This ensured a seamless experience for
            users and guaranteed that the website was working as intended.
          </p>
        </div>
        {/* <p className="heading-left">Functionality</p> */}
      </div>
      <div className="container left">
        <div className="content">
          <p>
            <span
              style={{
                color: "var(--main-color)",
                display: "block",
                marginBottom: "20px",
              }}
            >
              Speed
            </span>
            In addressing the issue of slow loading times, I optimized the
            website's images and code. This helped to improve the website's
            performance and ensure that users could access information quickly
            and efficiently.
          </p>
        </div>
        {/* <p className="heading-right">Speed</p> */}
      </div>
      <div className="container right">
        <div className="content">
          <p>
            <span
              style={{
                color: "var(--main-color)",
                display: "block",
                marginBottom: "20px",
              }}
            >
              Enhancing Website Performance and User Experience
            </span>
            I recommended and implemented Google Analytics to track the
            website's performance, user behavior, and engagement. This data can
            be used to make informed decisions about future updates and
            improvements to the website. Regular communication and collaboration
            between the client and web development team can help ensure that the
            website is always meeting the client's needs and goals.
          </p>
        </div>
        {/* <p className="heading-left">Outcome</p> */}
      </div>
      <div className="container left">
        <div className="content">
          <p>
            <span
              style={{
                color: "var(--main-color)",
                display: "block",
                marginBottom: "20px",
              }}
            >
              Outcome
            </span>
            Finally, I tested the website rigorously to ensure that it was
            working correctly and that users could navigate it with ease. The
            outcome was a modern, user-friendly, and optimized website that
            positively reflects the client's brand and enhances their online
            presence. The website now provides a seamless user experience, is
            responsive, and loads quickly, ultimately leading to increased
            revenue for the client.
          </p>
        </div>
        {/* <p className="heading-right">Solution</p> */}
      </div>
      <div className="container right">
        <div className="content">
          <p>
            <span
              style={{
                color: "var(--main-color)",
                display: "block",
                marginBottom: "20px",
              }}
            >
              Conclusion
            </span>
            This case study highlights the significance of comprehensive
            analysis, rigorous testing, and a focus on user experience when
            enhancing an outdated website to positively impact revenue. By
            focusing on the design, functionality, and speed of the website, I
            was able to deliver a product that met the client's needs and
            exceeded their expectations.
          </p>
        </div>
        {/* <p className="heading-left">Conclusion</p> */}
      </div>
    </div>
  );
};

export default VerticalTimeline;
